import type { ReactNode } from 'react';
import clsx from 'clsx';

export function Card({
  title,
  className,
  children,
  action,
}: {
  title?: ReactNode;
  className?: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className={clsx('card', className)}>
      {title && (
        <div className="flex items-center justify-between border-b border-gray-100 px-4 py-2.5">
          <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export function Kpi({
  label,
  value,
  hint,
  tone = 'default',
}: {
  label: string;
  value: ReactNode;
  hint?: string;
  tone?: 'default' | 'good' | 'warn' | 'bad';
}) {
  const toneCls = {
    default: 'text-gray-900',
    good: 'text-green-700',
    warn: 'text-amber-700',
    bad: 'text-red-700',
  }[tone];
  return (
    <div className="card flex flex-col gap-1 p-4">
      <div className="text-xs uppercase tracking-wide text-gray-500">{label}</div>
      <div className={clsx('text-2xl font-semibold tabular-nums', toneCls)}>{value}</div>
      {hint && <div className="text-xs text-gray-500">{hint}</div>}
    </div>
  );
}
